import React from 'react';
import {Link} from 'react-router-dom';

import classes from './CategoryTab.module.css';

const CategoryTab = (props) => {
    //console.log(props);

    const link = '/category/' + props.category;

    return (
        <div className={classes.CategoryTab} >
                
                    <div className={classes.CategoryInnerWrapper}>
                        <Link to={link} className={classes.CategoryLinkWrapper}>
                            <h2>{props.name}</h2>
                        </Link>
                    </div>
                
        </div>
    )
}

export default CategoryTab;
